import {Text} from "@mantine/core";
import React from "react";
import {DEFAULT_STYLES} from "../../global/themeStyles";

export function SectionLabel({color, children, className}: { color?: string, children: any, className?: any}) { //Label for a section in creatDocument.

    return <Text className={className === undefined ? undefined : className} style={{margin: 0}} weight={400} size={13} color={color ? color : DEFAULT_STYLES.descriptionColor} >{children}</Text>
}

